import React, { useMemo } from 'react';
import { SelectField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { ChargeBucketRef } from 'modules/equipment/types';
import { ListingForm } from 'components/shared/TableListing/types';

import type { ChargeListingService } from '../../../../../lib';
import { QuoteChargeListingEntity } from '../../../../../types';

interface Props {
  rowIndex: number;
  scope: ChargeBucketRef;
  chargeService: ChargeListingService;
}

// Only internal-only rows render this, so the whole-array subscription stays limited to those rows
export const RollUpSelect = ({ rowIndex, scope, chargeService }: Props) => {
  const { control, setValue } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const rows = useWatch({ control, name: 'bodyFields' });

  const parentOptions = useMemo(
    () => chargeService.buildParentOptions({ rows: rows ?? [], currentRowIndex: rowIndex, scope }),
    [rows, rowIndex, scope, chargeService]
  );

  const handleParentPicked = (nextValue: string | number | boolean) => {
    const kind = parentOptions.find(option => String(option.value) === String(nextValue))?.kind;

    setValue(`bodyFields.${rowIndex}.charge.parentType`, kind ?? 'charge', { shouldValidate: true });
  };

  return (
    <SelectField
      control={control}
      variant="outlined"
      label="Roll up into"
      options={parentOptions}
      extraAction={handleParentPicked}
      name={`bodyFields.${rowIndex}.charge.parentId`}
    />
  );
};
